import React from 'react';

const ServiceAreas = () => {
    return (
        <section className="section" id="areas">
            <div className="container service-areas">
                <div className="service-areas__text">
                    <h2 className="section__title">Serving Your Neighborhood</h2>
                    <p>
                        We provide cleaning services across Guelph, Kitchener, Waterloo, and Cambridge.
                        Whether it’s a one-time deep clean or ongoing maintenance, we’ve got you covered.
                    </p>
                    <p className="section__note">
                        Not sure if we cover your area? Include your address in the quote form and we’ll
                        confirm.
                    </p>
                </div>
                <div className="service-areas__cards">
                    <div className="area-card">Guelph</div>
                    <div className="area-card">Kitchener</div>
                    <div className="area-card">Waterloo</div>
                    <div className="area-card">Cambridge</div>
                </div>
            </div>
        </section>
    );
};

export default ServiceAreas;
